<template>
  <div>
    <!-- Selector de sensores -->
    <b-row>
      <b-col cols="6">
        <p class="text-left">Visualización/configuración de alertas por sensor</p>
      </b-col>
      <b-col>
        <b-row>
          <b-col class="selSensor text-right">Seleccionar sensor</b-col>
          <b-col>
            <b-form-select
              size="sm"
              id="sensors"
              name="sensors"
              v-model="selectedSensor"
              style="cursor: pointer"
            >
              <b-form-select-option value="null">
                Sensor no seleccionado
              </b-form-select-option>

              <b-form-select-option
                v-for="(sensor, index) in sensorList"
                v-bind:key="index"
                v-bind:value="sensor"
              >
                {{ sensor.description }}
              </b-form-select-option>
            </b-form-select>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- Formulario doble, uno con los datos calculados y otro para establecer las tolerancias -->
    <div id="formulario-alertas" style="width: 100%">
      <b-form @submit="updateShmAlertConfig">
        
        <!-- Fila 1: Títulos -->
        <b-row>
          <b-col>
            <p class="titulo1 text-center">Desviaciones de las medias (f1 a f8) respecto al valor de referencia configurado</p>
          </b-col>
          <b-col>
            <p class="titulo1 text-center">Tolerancia de alerta de las medias (configurable)</p>
          </b-col>
          <b-col>
            <p class="titulo1 text-center">Estado de alerta del sensor</p>
          </b-col>
        </b-row>

        <!-- Filas 2 a 9: Medias, umbrales y alarmas -->
        <b-row>
          <b-col>
            <b-form-group
              label-size="sm"
              label="Desviación media f1"
              label-for="media1"
            >
              <b-form-input
                id="media1"
                name="media1"
                size="sm"
                v-model="meansDeviationsList.frecuencia1"
                :value="meansDeviationsList.frecuencia1"
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label-size="sm"
              label="Tolerancia alerta f1"
              label-for="tolerancia1"
            >
              <b-form-input
                id="tolerancia1"
                name="tolerancia1"
                size="sm"
                placeholder="..."
                v-model="toleranceList.frecuencia1"
                :value="toleranceList.frecuencia1"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col style="display: flex">
            <div class="circleContainer">
              <div class="greenDot" v-if="alertList.frecuencia1=='green'"></div>
              <div class="yellowDot" v-else-if="alertList.frecuencia1=='yellow'"></div>
              <div class="redDot" v-else-if="alertList.frecuencia1=='red'"></div>
            </div>
          </b-col>
        </b-row>

        <!--------------------------------------------------------------------------------->
        <b-row>
          <b-col>
            <b-form-group
              label-size="sm"
              label="Desviación media f2"
              label-for="media2"
            >
              <b-form-input
                id="media2"
                name="media2"
                size="sm"
                v-model="meansDeviationsList.frecuencia2"
                :value="meansDeviationsList.frecuencia2"
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label-size="sm"
              label="Tolerancia alerta f2"
              label-for="tolerancia2"
            >
              <b-form-input
                id="tolerancia2"
                name="tolerancia2"
                size="sm"
                placeholder="..."
                v-model="toleranceList.frecuencia2"
                :value="toleranceList.frecuencia2"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col style="display: flex">
            <div class="circleContainer">
              <div class="greenDot" v-if="alertList.frecuencia2=='green'"></div>
              <div class="yellowDot" v-else-if="alertList.frecuencia2=='yellow'"></div>
              <div class="redDot" v-else-if="alertList.frecuencia2=='red'"></div>
            </div>
          </b-col>
        </b-row>

        <!--------------------------------------------------------------------------------->
        <b-row>
          <b-col>
            <b-form-group
              label-size="sm"
              label="Desviación media f3"
              label-for="media3"
            >
              <b-form-input
                id="media3"
                name="media3"
                size="sm"
                v-model="meansDeviationsList.frecuencia3"
                :value="meansDeviationsList.frecuencia3"
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label-size="sm"
              label="Tolerancia alerta f3"
              label-for="tolerancia3"
            >
              <b-form-input
                id="tolerancia3"
                name="tolerancia3"
                size="sm"
                placeholder="..."
                v-model="toleranceList.frecuencia3"
                :value="toleranceList.frecuencia3"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col style="display: flex">
            <div class="circleContainer">
              <div class="greenDot" v-if="alertList.frecuencia3=='green'"></div>
              <div class="yellowDot" v-else-if="alertList.frecuencia3=='yellow'"></div>
              <div class="redDot" v-else-if="alertList.frecuencia3=='red'"></div>
            </div>
          </b-col>
        </b-row>

        <!--------------------------------------------------------------------------------->
        <b-row>
          <b-col>
            <b-form-group
              label-size="sm"
              label="Desviación media f4"
              label-for="media4"
            >
              <b-form-input
                id="media4"
                name="media4"
                size="sm"
                v-model="meansDeviationsList.frecuencia4"
                :value="meansDeviationsList.frecuencia4"
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label-size="sm"
              label="Tolerancia alerta f4"
              label-for="tolerancia4"
            >
              <b-form-input
                id="tolerancia4"
                name="tolerancia4"
                size="sm"
                placeholder="..."
                v-model="toleranceList.frecuencia4"
                :value="toleranceList.frecuencia4"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col style="display: flex">
            <div class="circleContainer">
              <div class="greenDot" v-if="alertList.frecuencia4=='green'"></div>
              <div class="yellowDot" v-else-if="alertList.frecuencia4=='yellow'"></div>
              <div class="redDot" v-else-if="alertList.frecuencia4=='red'"></div>
            </div>
          </b-col>
        </b-row>

        <!--------------------------------------------------------------------------------->
        <b-row>
          <b-col>
            <b-form-group
              label-size="sm"
              label="Desviación media f5"
              label-for="media5"
            >
              <b-form-input
                id="media5"
                name="media5"
                size="sm"
                v-model="meansDeviationsList.frecuencia5"
                :value="meansDeviationsList.frecuencia5"
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label-size="sm"
              label="Tolerancia alerta f5"
              label-for="tolerancia5"
            >
              <b-form-input
                id="tolerancia5"
                name="tolerancia5"
                size="sm"
                placeholder="..."
                v-model="toleranceList.frecuencia5"
                :value="toleranceList.frecuencia5"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col style="display: flex">
            <div class="circleContainer">
              <div class="greenDot" v-if="alertList.frecuencia5=='green'"></div>
              <div class="yellowDot" v-else-if="alertList.frecuencia5=='yellow'"></div>
              <div class="redDot" v-else-if="alertList.frecuencia5=='red'"></div>
            </div>
          </b-col>
        </b-row>

        <!--------------------------------------------------------------------------------->
        <b-row>
          <b-col>
            <b-form-group
              label-size="sm"
              label="Desviación media f6"
              label-for="media6"
            >
              <b-form-input
                id="media6"
                name="media6"
                size="sm"
                v-model="meansDeviationsList.frecuencia6"
                :value="meansDeviationsList.frecuencia6"
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label-size="sm"
              label="Tolerancia alerta f6"
              label-for="tolerancia6"
            >
              <b-form-input
                id="tolerancia6"
                name="tolerancia6"
                size="sm"
                placeholder="..."
                v-model="toleranceList.frecuencia6"
                :value="toleranceList.frecuencia6"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col style="display: flex">
            <div class="circleContainer">
              <div class="greenDot" v-if="alertList.frecuencia6=='green'"></div>
              <div class="yellowDot" v-else-if="alertList.frecuencia6=='yellow'"></div>
              <div class="redDot" v-else-if="alertList.frecuencia6=='red'"></div>
            </div>
          </b-col>
        </b-row>

        <!--------------------------------------------------------------------------------->
        <b-row>
          <b-col>
            <b-form-group
              label-size="sm"
              label="Desviación media f7"
              label-for="media7"
            >
              <b-form-input
                id="media7"
                name="media7"
                size="sm"
                v-model="meansDeviationsList.frecuencia7"
                :value="meansDeviationsList.frecuencia7"
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label-size="sm"
              label="Tolerancia alerta f7"
              label-for="tolerancia7"
            >
              <b-form-input
                id="tolerancia7"
                name="tolerancia7"
                size="sm"
                placeholder="..."
                v-model="toleranceList.frecuencia7"
                :value="toleranceList.frecuencia7"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col style="display: flex">
            <div class="circleContainer">
              <div class="greenDot" v-if="alertList.frecuencia7=='green'"></div>
              <div class="yellowDot" v-else-if="alertList.frecuencia7=='yellow'"></div>
              <div class="redDot" v-else-if="alertList.frecuencia7=='red'"></div>
            </div>
          </b-col>
        </b-row>

        <!--------------------------------------------------------------------------------->
        <b-row>
          <b-col>
            <b-form-group
              label-size="sm"
              label="Desviación media f8"
              label-for="media8"
            >
              <b-form-input
                id="media8"
                name="media8"
                size="sm"
                v-model="meansDeviationsList.frecuencia8"
                :value="meansDeviationsList.frecuencia8"
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label-size="sm"
              label="Tolerancia alerta f8"
              label-for="tolerancia8"
            >
              <b-form-input
                id="tolerancia8"
                name="tolerancia8"
                size="sm"
                placeholder="..."
                v-model="toleranceList.frecuencia8"
                :value="toleranceList.frecuencia8"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col style="display: flex">
            <div class="circleContainer">
              <div class="greenDot" v-if="alertList.frecuencia8=='green'"></div>
              <div class="yellowDot" v-else-if="alertList.frecuencia8=='yellow'"></div>
              <div class="redDot" v-else-if="alertList.frecuencia8=='red'"></div>
            </div>
          </b-col>
        </b-row>

        <!-- fila 10, botón para almacenar tolerancias y resultado general del sensor -->
        <b-row>
          <b-col>
            <!-- Columna vacía para cuadrar esta última fila -->
          </b-col>
          
          <b-col>
            <b-button
              block
              type="submit"
              name="updateShmAlertConfig"
              id="updateShmAlertConfig"
              variant="success"
              size="sm"
            >
              <i class="fas fa-edit"></i>
              <span
                class="text-uppercase"
                style="
                  font-size: 12px;
                  font-weight: bold;
                  margin-left: 5px;
                "
                >Guardar valores de tolerancia</span
              >
            </b-button>
          </b-col>
          
          <b-col>
            <!-- Columna vacía para cuadrar y por si queremos añadir algún tipo de resumen --->
          </b-col>
        </b-row>

      </b-form>
    </div>
  </div>
</template>


<script>
import "vue-good-table/dist/vue-good-table.css";
import GroupService from "@/services/GroupService";

export default {
  name: "desv-list",
  data() {
    return {
      selectedSensor: null,
      sensorList: [],
      idsensor: null,
      idgroup: null,
      isLoading: false,
      meansDeviationsList: {},
      toleranceList: {},
      alertList: {}      
    };
  },
  components: {

  },
  watch: {
    selectedSensor: function (newVal, oldVal) {
      return this.retrieveAlertInfo(newVal);
    },
  },
  methods: {
    /* Rellenar la tabla con los datos del backend*/
    async retrieveAlertInfo(sensor) {
      await GroupService.getAlertInfoFromSensorId(sensor._id)
      .then(response => {
        if (response.data) {
          let shmAlertInfo = response.data;

          this.meansDeviationsList = shmAlertInfo.mean;
          this.toleranceList = shmAlertInfo.tolerance;
          this.alertList = shmAlertInfo.alert;

          /**
           * TODO:
           * TENEMOS QUE CALCULAR EL COLOR DE LA ALARMA FINAL
           * PERO AUN NO TENEMOS NI EL NOMBRE DEL CAMPO FINAL
           */
        }
      })
      .catch(err => {
        console.log("Error recuperando la información de las alertas")
        console.log(err)
      })
    },

    async updateShmAlertConfig(e) {
      e.preventDefault();

      GroupService.updateAlertInfoFromSensorId(this.selectedSensor._id, this.toleranceList)
      .then(response => {
        this.retrieveAlertInfo(this.selectedSensor)
      })
      .catch(err => {
        console.log("Error actualizando valores de tolerancias para las alarmas")
        console.log(err)
      })
      
    },

    //Llenar el listado del desplegable, metemos el objeto completo para tenerlo todo identificado
    //Solo llenamos el array con los elementos SHM
    async populateSelector(groupData) {
      this.sensorList = [];
      
      for await (let sensor of groupData.sensor)
        if(sensor.isShm){
          this.sensorList.push(sensor)
        }
      // Seleccionar un elemento como primario para desplegarlo
      this.selectedSensor = this.sensorList[0]        
    }   
  },
};
</script>

<style>
.selSensor {
  padding: 3px;
  font-size: 0.95rem;
  color: #606266;
  font-weight: 400;
}

.titulo1 {
  font-size: 0.95rem;
  color: #606266;
  text-align: center;
  font-weight: 400;
}

.greenDot {
  height: 25px;
  width: 25px;
  background-color: #008000;
  border-radius: 50%;
  display: inline-block;
}

.yellowDot {
  height: 25px;
  width: 25px;
  background-color: #FFFF00;
  border-radius: 50%;
  display: inline-block;
}

.circleContainer {
  margin: auto;
  position: relative
}

.redDot {
  height: 25px;
  width: 25px;
  background-color: #FF0000;
  border-radius: 50%;
  display: inline-block;
}
</style>
